import React from "react";
import classes from "./ContactDetails.module.css";
import { AddressData } from "../utils";
import { t } from "i18next";

type Props = {
  address: AddressData;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errors: { [key: string]: string };
};

export const AddressForm: React.FC<Props> = ({
  address,
  handleChange,
  errors,
}) => {
  const countryCode = sessionStorage.getItem("country") || "";

  const requiredFieldsMap: Record<string, string[]> = {
    JP: ["zipcode", "state", "city", "line1", "country"],
    KR: ["zipcode", "state", "city", "line1", "country"],
    HK: ["city", "line1", "country"],
    SG: ["zipcode", "city", "line1", "country"],
    TW: ["zipcode", "city", "line1", "country"],
  };

  const defaultRequiredFields = [
    "zipcode",
    "state",
    "city",
    "line1",
    "country",
  ];

  const requiredFields =
    requiredFieldsMap[countryCode as keyof typeof requiredFieldsMap] ||
    defaultRequiredFields;

  const isRequired = (field: string) => requiredFields.includes(field);

  return (
    <fieldset className={classes.address_fieldset}>
      <legend>{t("form.address")}</legend>

      <div className={classes.form_group}>
        <label htmlFor="line1">
          {t("form.address_line1")}
          {isRequired("line1") && "*"}
        </label>
        <input
          id="line1"
          name="line1"
          value={address.line1}
          onChange={handleChange}
          placeholder={t("form.address_line1_placeholder")}
        />
        {errors.line1 && <div className={classes.error}>{errors.line1}</div>}
      </div>

      <div className={classes.form_group}>
        <label htmlFor="line2">{t("form.address_line2")}</label>
        <input
          id="line2"
          name="line2"
          value={address.line2}
          onChange={handleChange}
          placeholder={t("form.address_line2_placeholder")}
        />
      </div>

      <div className={classes.form_group}>
        <label htmlFor="city">
          {t("form.city")}
          {isRequired("city") && "*"}
        </label>
        <input
          id="city"
          name="city"
          value={address.city}
          onChange={handleChange}
          placeholder={t("form.city")}
        />
        {errors.city && <div className={classes.error}>{errors.city}</div>}
      </div>

      <div className={classes.form_group}>
        <label htmlFor="state">
          {t("form.state")}
          {isRequired("state") && "*"}
        </label>
        <input
          id="state"
          name="state"
          value={address.state}
          onChange={handleChange}
          placeholder={t("form.state")}
        />
        {errors.state && <div className={classes.error}>{errors.state}</div>}
      </div>

      <div className={classes.form_group}>
        <label htmlFor="country">
          {t("form.country")}
          {isRequired("country") && "*"}
        </label>
        <input
          id="country"
          name="country"
          value={address.country}
          onChange={handleChange}
          placeholder={t("form.country")}
        />
        {errors.country && (
          <div className={classes.error}>{errors.country}</div>
        )}
      </div>

      <div className={classes.form_group}>
        <label htmlFor="zipcode">
          {t("form.zip_code")}
          {isRequired("zipcode") && "*"}
        </label>
        <input
          id="zipcode"
          name="zipcode"
          value={address.zipcode}
          onChange={handleChange}
          placeholder={t("form.zip_code_placeholder")}
        />
        {errors.zipcode && (
          <div className={classes.error}>{errors.zipcode}</div>
        )}
      </div>
    </fieldset>
  );
};
